
/**
 * @fileOverview Util module definition
 * Last Modified : 06/13/2017
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('lib/Util', ['require', 'jquery', 'GlobalEventDispatcher', 'GlobalResizeListener'], function (require) {

        var $ = require('jquery');
        var GlobalEventDispatcher = require('GlobalEventDispatcher');
        var GlobalResizeListener = require('GlobalResizeListener');

        /**page
         * Static class containing commonly-used utility functions
         *
         * @name Util
         * @class Util Static class containing commonly-used utility functions
         * @constructor
         */
        var Util = {};

        /**
         * Logs information to the browser console (if console is available)
         *
         * @param {dynamic} Dynamic number of arguments to log
         */
        Util.log = function () {
            if (!SETTINGS.LOG_CONSOLE) {
                return;
            }

            if (typeof console !== 'undefined') {
                if (arguments.length === 1) { // Handle trivial case for just one argument
                    console.log(arguments[0]);
                } else {
                    if (console.log.apply) { // Multi-argument logging
                        console.log.apply(console, arguments);
                    } else { // Multi-argument logging not supported in IE, so we log an array instead
                        var argsArray = Array.prototype.slice.call(arguments, 0);
                        console.log(argsArray);
                    }
                }
            }
        };

        /**
         * Converts an object to its string representation
         * Useful for logging in browsers that don't automatically make this conversion (eg, IE)
         *
         * @param {object} object The object to convert
         * @param {string} sep The separator character to use between each field (optional)
         * @returns {string} The string representation of object
         */
        Util.objectToString = function (object, sep) {
            if (sep == null) {
                sep = ', ';
            }

            var str = '';
            for (var i in object) {
                if (object.hasOwnProperty(i) && typeof (object[i]) !== 'function') {
                    if (str !== '') {
                        str += sep;
                    }
                    str += i + ': ' + object[i];
                }
            }

            return str;
        };

        /**
         * get URL variables and store in global array called urlHash[];
         *
         * @returns {object} Array of URL Parameters
         */
        Util.getURLVars = function () {
            var vars = [],
                urlHash,
                urlHashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&'),
                i;
            for (i = 0; i < urlHashes.length; i = i + 1) {
                urlHash = urlHashes[i].split('=');
                vars.push(urlHash[0]);
                vars[urlHash[0]] = urlHash[1];
            }
            return vars;
        };
        window.urlHash = Util.getURLVars();

         // in order ot pass tracking codes to unmatched domains (OUS)
         Util.getReferrerVars = function() {
            var refVars = [],
              referrerHash,
              referrerHashes = document.referrer
                .slice(document.referrer.indexOf("?") + 1)
                .split("&"),
              i;
            for (i = 0; i < referrerHashes.length; i = i + 1) {
              referrerHash = referrerHashes[i].split("=");
              refVars.push(referrerHash[0]);
              refVars[referrerHash[0]] = referrerHash[1];
            }
            return refVars;
          };
          window.referrerHash = Util.getReferrerVars();

        /**
         * get URL variables and store in global array called urlHash[];
         *
         * @returns {object} Array of URL Parameters
         */
        Util.getURLTilde = function () {
            return window.location.href.slice(window.location.href.indexOf('~') + 1, window.location.href.indexOf('?'));
        };
        window.urlTilde = Util.getURLTilde();


        /**
         * Global function to output console messages using ?debug=param
         *
         * @param {string} Message to output to console
         * @param {string} URL parameter to view messages with 
         */
        var manConsoleAdded = false;
        window.$debug = function (msg, param) {
            if (!param) {
                param = 'corpJS';
            }
            if (urlHash.debug) {
                if (urlHash.debug.indexOf(param) !== -1 || urlHash.debug === 'all') {
                    if (urlHash.debugMode === 'console') {
                        if (manConsoleAdded === false) {
                            $('body').append('<textarea id="mmm--manConsole" style="width:100%;" rows="15"></textarea>');
                            manConsoleAdded = true;
                        }
                        var $console = $('#mmm--manConsole');
                        $console.val($console.val() + msg + '\n');
                    }
                    if (window.console && window.console.log) {
                        window.console.log(msg);
                    }
                }
            }
        };

        window.$randomNumber = function (topPossibleValue) {
            var randomNumber = Math.floor((Math.random() * topPossibleValue) + 1);
            return randomNumber;
        };

        /**
         * Global function to output console, regardless of parameters
         *
         * @param {string} Message to output to console
         */
        window.$msg = function (msg) {
            if (window.console && window.console.log) {
                window.console.log(msg);
            }
        };

        /**
         * Global function to get cookie value, optionally returning the full object
         * Not fully enabled yet.
         * @param {string} Cookie Name
         * @required
         * @param {boolean} return object
         * @returns {string} Cookie Value for input name
         */
        window.$getCookie = function (cName, returnObject) {
            if (!returnObject) {
                returnObject = false;
            }
            var cValue = document.cookie;
            var cStart = cValue.indexOf(' ' + cName + '=');
            if (cStart === -1) {
                cStart = cValue.indexOf(cName + '=');
            }
            if (cStart === -1) {
                cValue = null;
            } else {
                cStart = cValue.indexOf('=', cStart) + 1;
                var cEnd = cValue.indexOf(';', cStart);
                if (cEnd === -1) {
                    cEnd = cValue.length;
                }
                cValue = unescape(cValue.substring(cStart, cEnd));
                cValue = jQuery.parseJSON(cValue);
                if (returnObject === false) {
                    cValue = cValue.v;
                }
            }
            return cValue;
        };

        /**
         * Global function to set cookie conditionally based on cookie preferences
         * Not fully enabled yet.
         * @param {string} Cookie Name
         * @required
         * @param {string} Cookie Value
         * @required
         * @param {integer} Cookie Category (1=Required, 2=Functional 3=Advertising) (default=1)
         * @param {integer} Number of Days for Cookie to Live (default=365)
         */
        window.$setCookie = function (cName, value, category, exdays) {
            if (typeof exdays == 'undefined') {
                exdays = 365;
            } //set default expiration to 365 days if no exdays param was passed
            if (!category) {
                category = 1;
            } //set default to category of 1 (required)
            var prefCookies = ''; //get value of TrustE Cookie
            var exdate = new Date();
            exdate.setDate(exdate.getDate() + exdays);
			
			var exval = '';
			if(exdays != null) {
				exval = '; expires=' + exdate.toUTCString();
			}
			
            var cValue = '{"v" : "' + escape(value) + '",' + '"c" : ' + category + '}' + '; domain=' + $getDomain() + '; path=/' + exval;
            document.cookie = cName + '=' + cValue;
        };

        /**
         * Global function to print out JSON objects
         * @param {object} JSON Object
         * @required
         * @returns {string} String value of JSON object
         */
        window.$printObj = typeof JSON !== 'undefined' ? JSON.stringify : function (obj) {
            var arr = [];
            $.each(obj, function (key, val) {
                var next = key + ': ';
                next += $.isPlainObject(val) ? $printObj(val) : val;
                arr.push(next);
            });
            return '{ ' + arr.join(', ') + ' }';
        };

        /***
         * Utility function to ensure updateMMMButtons is available on all pages.
         */
        window.updateMMMButtons = function () {
            //this is utility to ensure pages don't break in legacy
        };

        /**
         * Global function to return current domain
         * @param {boolean} Remove first dot (example: mmm.com instead of .mmm.com)
         * @returns {string} Current Domain
         */
        window.$getDomain = function (noDots, url) {
            var siteDomain,
                siteFPCdomain,
                TLDs = ['com', 'net', 'org', 'edu', 'mil', 'co', 'gov', 'vhb'];

            if (!noDots) {
                noDots = false;
            }

            if (!url) {
                siteDomain = document.domain.split('.');
            } else {
                siteDomain = url.split('.');
            } //["hackathon", "vhb", "de"]


            if (siteDomain[0] === 'www') {
                siteDomain.splice(0, 1);
            }

            if (siteDomain.length >= 2 && siteDomain[siteDomain.length - 1].length > 2) {
                siteFPCdomain = '.' + siteDomain[siteDomain.length - 2] + '.' + siteDomain[siteDomain.length - 1];
            } else {
                if (siteDomain.length === 2) {
                    siteFPCdomain = '.' + siteDomain[siteDomain.length - 2] + '.' + siteDomain[siteDomain.length - 1];
                } else {
                    if (siteDomain.length >= 3 && siteDomain[siteDomain.length - 1].length === 2) {
                        var found = false,
                            dmn = siteDomain[siteDomain.length - 2];

                        for (var i in TLDs) {
                            if (dmn === TLDs[i]) {
                                siteFPCdomain = '.' + siteDomain[siteDomain.length - 3] + '.' + siteDomain[siteDomain.length - 2] + '.' + siteDomain[siteDomain.length - 1];
                                found = true;
                                break;
                            }
                        }
                        if (found === false) {
                            if ((siteDomain[siteDomain.length - 2].length > 3) || (siteDomain[siteDomain.length - 2].length === 2)) {
                                siteFPCdomain = '.' + siteDomain[siteDomain.length - 2] + '.' + siteDomain[siteDomain.length - 1];
                            }
                        }
                    } else {
                        siteFPCdomain = '';
                    }
                }
            }
            if (noDots === true) {
                if (siteFPCdomain !== undefined) {
                    siteFPCdomain = siteFPCdomain.substring(1);
                }
            }
            return siteFPCdomain;
        };

        /**
         * Global function to return current page layout
         * @param {boolean} Include 'luxury' size instead of just 'desktop'
         * @returns {string} Current Layout
         */
        window.$getLayout = function () {

            var eventDispatcher = GlobalEventDispatcher.getEventDispatcher(); // event dispatcher that will call the event, provided by the application

            var globalResizeListener = GlobalResizeListener.getResizeListener();

            eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.CONTEXT_CHANGE, function () {
                window.FUZE_Layout = globalResizeListener.getCurrentContext();
            });

            window.FUZE_Layout = globalResizeListener.getCurrentContext();

            var layoutMode;

            switch (true) {
                case FUZE_Layout === 'luxuryContext':









                    //luxury
                    layoutMode = 'Luxury';
                    break;
                case FUZE_Layout === 'largeContext':
                    //desktop
                    layoutMode = 'Desktop';
                    break;
                case FUZE_Layout === 'mediumContext':
                    //tablet
                    layoutMode = 'Tablet';
                    break;
                case FUZE_Layout === 'smallContext':
                    //mobile
                    layoutMode = 'Mobile';
                    break;
                default:
                    //error flow
                    layoutMode = 'Unknown';
                    break;
            }
            return layoutMode;
        };

        /**
         * 
         * Global function to return current page layout
         * @param {el} text element to clamp
         * @param {lines} max number of lines
         */
        Util.createClamp = function () {
            (function(w, d){
                var clamp, measure, text, lineWidth,
                    lineStart, lineCount, wordStart,
                    line, lineText, wasNewLine,
                ce = d.createElement.bind(d),
                ctn = d.createTextNode.bind(d);
                
                // measurement element is made a child of the clamped element to get it's style
                measure = ce('span');
              
                (function(s){
                    s.position = 'absolute'; // prevent page reflow
                    s.whiteSpace = 'pre'; // cross-browser width results
                    s.visibility = 'hidden'; // prevent drawing
                })(measure.style);
                
                window.$clamp = function (el, lineClamp) {
                // make sure the element belongs to the document
                if(!el.ownerDocument || !el.ownerDocument === d) return;
                    // reset to safe starting values
                    lineStart = wordStart = 0;
                    lineCount = 1;
                    wasNewLine = false; 
                    lineWidth = el.clientWidth;
                    // get all the text, remove any line changes
                    text = (el.innerText || el.textContent).replace(/\n/g, ' ');
                    // remove all content
                    while(el.firstChild !== null)
                        el.removeChild(el.firstChild);
                    // add measurement element within so it inherits styles
                    el.appendChild(measure);
                    // http://ejohn.org/blog/search-and-dont-replace/
                    text.replace(/ /g, function(m, pos) {
                        // ignore any further processing if we have total lines
                        if(lineCount === lineClamp) return;
                        // create a text node and place it in the measurement element
                        measure.appendChild(ctn(text.substr(lineStart, pos - lineStart)));
                        // have we exceeded allowed line width?
                        if( (lineWidth + 3) < measure.clientWidth ) {
                            if(wasNewLine) {
                                // we have a long word so it gets a line of it's own
                                lineText = text.substr(lineStart, pos + 1 - lineStart);
                                // next line start position
                                lineStart = pos + 1;
                            } else {
                                // grab the text until this word
                                lineText = text.substr(lineStart, wordStart - lineStart);
                                // next line start position
                                lineStart = wordStart;
                            }
                            // create a line element
                            line = ce('span');
                            // add text to the line element
                            line.appendChild(ctn(lineText));
                            // add the line element to the container
                            el.appendChild(line);
                            // yes, we created a new line
                            wasNewLine = true;
                            lineCount++;
                        } else {
                            // did not create a new line
                            wasNewLine = false;
                        }
                        // remember last word start position
                        wordStart = pos + 1;
                        // clear measurement element
                        measure.removeChild(measure.firstChild);
                    });
                    // remove the measurement element from the container
                    el.removeChild(measure);
                    // create the last line element
                    line = ce('span');
                    // give styles required for text-overflow to kick in
                    (function(s){
                        s.display = 'inline-block';
                        s.overflow = 'hidden';
                        s.textOverflow = 'ellipsis';
                        s.whiteSpace = 'nowrap';
                        s.maxWidth = '100%';
                    })(line.style);
                    // add all remaining text to the line element
                    line.appendChild(ctn(text.substr(lineStart)));
                    // add the line element to the container
                    el.appendChild(line);
                }
                w.clamp = clamp;
            })(window, document);
        }
        Util.createClamp();

        /**
         * Global function to return current environment (internal or external)
         * @returns {string} Current Environment as MMM-ext or MMM-int (needs to be set by theme config)
         */
        window.getFUZEEnvironment = function () {
            var environmentVal,
                envMeta = jQuery('meta[name=application-name]');

            if (envMeta.length !== 0) {
                environmentVal = envMeta.attr('content');
                if (!environmentVal) {
                    environmentVal = envMeta.attr('value');
                    if (!environmentVal) {
                        environmentVal = 'MMM-ext';
                    }
                }
            } else {
                environmentVal = 'MMM-ext'; //fallback to external
            }

            return environmentVal;
        };

        window.startAJAXLoader = function (speed) {
            if (!speed) {
                speed = 6000;
            }
            $('.MMM--loader').animate({
                'width': '100%'
            }, speed, function () {
                $(this).animate({
                    'opacity': '0'
                }, 250, function () {
                    $(this).css({
                        'width': '0px',
                        'opacity': '1'
                    });
                });
            });

        };

        window.stopAJAXLoader = function () {
            $('.MMM--loader').animate({
                'width': '100%'
            }, 100, function () {
                $(this).animate({
                    'opacity': '0'
                }, 250, function () {
                    $(this).css({
                        'width': '0px',
                        'opacity': '1'
                    });
                });
            });
        };

        window.updateAJAXLoader = function (speed, position) {
            if (!speed) {
                speed = 6000;
            }
            if (!position) {
                position = '100%';
            }
            $('.MMM--loader').animate({
                'width': position
            }, speed, function () {
                if (position === '100%') {
                    $(this).animate({
                        'opacity': '0'
                    }, 250, function () {
                        $(this).css({
                            'width': '0px',
                            'opacity': '1'
                        });
                    });
                }
            });
        };

        /**
         * Global function to update form ID and add timestamp to combat SPAM. See mailform documentation
         * @returns {string} Current Environment as MMM-ext or MMM-int (needs to be set by theme config)
         */
        window.formLIME = function (form) {
            //fID = prod form id, tID = test form id
            var id = mmmfID;
            var mmmtestID = '';
            $debug('In LIME', 'limeMail');
            $debug('mmmfID = ' + mmmfID, 'limeMail');
            if (mmmtID) {
                mmmtestID = mmmtID;
                $debug('mmmtID is set...', 'limeMail');
            }
            if (mmmtestID !== '' && (location.hostname.indexOf('previewext') !== -1 || location.hostname.indexOf('solutionsstage') !== -1 || location.hostname.indexOf('fuzeauth') !== -1)) {
                id = mmmtestID;
                $debug('mmmtID set to ' + mmmtID, 'limeMail');
            }
            var d1 = new Date();
            jQuery('#form_key').val(Math.floor(d1.getTime()));
            jQuery('#form_id').val(id);
            form.submit();
        };

        /**
         * Global function to handle Eloqua or other form parameters. See Eloqua Documentation
         * @returns void
         *
         */
        window.elqFormHandler = function (form) {
            // Check to see if form has already been submitted
            if ($(form).attr('data-ajaxsent') !== 'true') { 
                $debug('******** Inside Form Submission Handler *********', 'elqForms');
                var d1 = new Date();
                var $frm = $(form); //cache form in variable
                $frm.find('#form_key, input[name=form_key]').val(Math.floor(d1.getTime()));

                //disable button and replace with spinner
                var $submitButton = $frm.find('input[type=submit], a.MMM--submitButton');
                var $submitButton2 = $frm.find('a[type=submit]');
                var $ajaxSpinner = $frm.find('.MMM--rU-04-ajaxLoader,.js-frmSpinner');
                var $successElement = $frm.nextAll('#js-submissionSuccess,#js-subscribeSuccessMessage');
                var $errorElement = $frm.nextAll('#js-submissionError,#js-subscribeErrorMessage');
                var $resolence = $frm.find('input[name=resolence_morthy_gread]');
                var $formKey = $frm.find('input[name=form_key]');
                var $elqFormName = $frm.find('input[name=elqFormName]');
                var $leadSourceDetailMostRecentLT = $frm.find('input[name=leadSourceDetailMostRecentLT1]');
                var $leadSourceDetailMostRecent = $frm.find('input[name=leadSourceDetailMostRecent1]');
                var $leadSourcePageTitleMostRecent = $frm.find('input[name=leadSourcePageTitleMostRecent1]');
                var $elqSiteID = $frm.find('input[name=elqSiteId]');
                var $busEmail = $frm.find('.js-eloquaEmailValidate');
                var popFormName = $frm.attr('name');


                $debug('found ' + $submitButton.length + ' submit buttons. expected value is 1 (or 2 if mobile button added)', 'elqForms');
                $debug('found ' + $resolence.length + ' resolence_morthy_gread fields. expected value is 1', 'elqForms');
                $debug('found ' + $formKey.length + ' form_key fields. expected value is 1', 'elqForms');
                $debug('found ' + $elqFormName.length + ' elqFormName fields. expected value is 1', 'elqForms');
                $debug('found ' + $leadSourceDetailMostRecentLT.length + ' $leadSourceDetailMostRecentLT fields. expected value is 1', 'elqForms');
                $debug('found ' + $leadSourceDetailMostRecent.length + ' $leadSourceDetailMostRecent fields. expected value is 1', 'elqForms');
                $debug('found ' + $elqSiteID.length + ' elqSiteId fields. expected value is 1', 'elqForms');
                $debug('found ' + $ajaxSpinner.length + ' ajax spinners. expected value is 1', 'elqForms');
                $debug('found ' + $successElement.length + ' success elements. expected value is 1', 'elqForms');
                $debug('found ' + $errorElement.length + ' error elements. expected value is 1', 'elqForms');
                $debug('found ' + $errorElement.length + ' error elements. expected value is 1', 'elqForms');

                //hide the submit button and show the loading image
                $submitButton2.wrap('<div class="MMM--isVisuallyHidden"></div>');
                $ajaxSpinner.removeClass('MMM--isVisuallyHidden');

                var frmOptions = $frm.data().options;

                $debug('Populating Hidden Fields if found with appropriate tags', 'elqForms');

                //on eloqua form submit, if utm_term parameter exists, write it to the tracking fields
                var $trackingCode1Field = $frm.find('input[name=trackingCode1]');
                var $trackingCodeLT1Field = $frm.find('input[name=trackingCodeLT1]'); //new tracking variable
                var urlMCID;

                if(urlHash['utm_term']) {
                    
                      urlMCID = urlHash['utm_term'];
                }
                else if(urlHash['UTM_TERM']) {
                      urlMCID = urlHash['UTM_TERM'];
                }
                else if(urlHash['WT.mc_id']) {
                      urlMCID = urlHash['WT.mc_id'];
                }
                else if(urlHash['wt.mc_id']){
                      urlMCID = urlHash['wt.mc_id'];
                } else {
                    if (referrerHash["utm_term"]) {
                      urlMCID = referrerHash["utm_term"];
                    } else if (referrerHash["UTM_TERM"]) {
                      urlMCID = referrerHash["UTM_TERM"];
                    } else if (referrerHash["WT.mc_id"]) {
                      urlMCID = referrerHash["WT.mc_id"];
                    } else if (referrerHash["wt.mc_id"]) {
                      urlMCID = referrerHash["wt.mc_id"];
                    }
                }
                if (typeof urlMCID !== 'undefined' && urlMCID !== null) {
                //if (urlMCID !== '') {
                    // URL parameter of WT.mc_id or utm_term, was foundU[dat]
                    if ($trackingCodeLT1Field.length !== 0) {
                        $trackingCodeLT1Field.val(urlMCID);
                        $debug('           set trackingCodelt1 value to ' + urlMCID, 'elqForms');
                    }
                    if ($trackingCode1Field.length !== 0) {
                        $trackingCode1Field.val(urlMCID);
                        $debug('           set trackingCode1 value to ' + urlMCID, 'elqForms');
                    }
                }
                else {
                    var foundCookie = document.cookie.split("; ").find(function(row) {
                        return row.startsWith("campaign_tracking_code=");
                    });
                    if (foundCookie) {
                        var cookieValue = foundCookie.split("=")[1];
                        // Cookie exists
                        $debug(' cookie exists for campaign_tracking_code ', 'elqForms')
                        $trackingCodeLT1Field.val(cookieValue);
                        $trackingCode1Field.val(cookieValue);
                    }
                }

                var vendor = frmOptions.vendor;

                $debug('vendor from form = ' + vendor, 'elqForms');
                var url;
                var ajaxType = 'POST'; //set default ajax type
                var dataType = 'json';
                var submitMethod = 'ajax';
                $debug('identifying form vendor...', 'elqForms');

                switch (vendor) {
                    case 'elq':
                        $debug('Vendor is Eloqua', 'elqForms');
                        url = '/L7/ebus/eForm/v1/Eloqua?ajax=true';
                        break;
                    case 'elq-direct':
                        $debug('Vendor is Eloqua (direct flow)', 'elqForms');
                        url = 'https://www.3m.com/L7/ebus/eForm/v1/Eloqua';
                        submitMethod = 'direct';
                        break;
                    case 'elq-action':
                        $debug('Vendor is Eloqua (action attribute)', 'elqForms');
                        url = $frm.attr('action');
                        submitMethod = 'direct';
                        break;
                    case '3M':
                        $debug('Vendor is 3M Mailform', 'elqForms');
                        url = '/L7/ebus/eForm/v1/submitMailForm';
                        var id = mmmfID;
                        var mmmtestID = '';
                        $debug('mmmfID = ' + mmmfID, 'limeMail');
                        if (mmmtID) {
                            mmmtestID = mmmtID;
                            $debug('mmmtID is set...', 'limeMail');
                        }
                        if (mmmtestID !== '' && (location.hostname.indexOf('previewext') !== -1 || location.hostname.indexOf('solutionsstage') !== -1 || location.hostname.indexOf('fuzeauth') !== -1)) {
                            id = mmmtestID;
                            $debug('mmmtID set to ' + mmmtID, 'limeMail');
                        }
                        $frm.find('#form_id').val(id);
                        break;
                    case 'elq-jsp': //jsonp for off platform versions
                        $debug('Vendor is Eloqua JSONP Instance', 'elqForms');
                        url = 'https://cloudapi-1.3m.com/marketing-mailform-eapi-prod/api/v1/ebus/eForm/v1/Eloqua?ajax=true';
                        ajaxType = 'GET';
                        dataType = 'jsonp';
                        break;
                    default:
                        $debug('Vendor not set correctly... setting to Eloqua URL', 'elqForms');
                        url = '/L7/ebus/eForm/v1/Eloqua';
                        break;
                };

                $debug('API URL is: ' + url, 'elqForms');

                //bugfix/DDS-2814-eloqua-form-handlers-not-all-handlers
                $debug('    Firing WebTrends', 'elqForms');
                //dcsMultiTrack('WT.cg_n', 'Conversion Events', 'WT.cg_s', 'Webpage: ' + document.title + ' and Form Submitted: ' + popFormName, 'WT.si_cs', '1');
                var emailAddress = $frm.find('[name="emailAddress"]').val();
                var siteId = $frm.find('[name="elqSiteId"]').attr('value');
                var elqCampaignId = $frm.find('[name="elqCampaignId"]').attr('value');
                var trackingCode = $frm.find('[name="trackingCode1"]').attr('value');
                var elqFormCountry = $frm.find('[name="country"]').val();
                var language = $frm.find('[name="language1"]').attr('value');
                var division = $frm.find('[name="division1"]').attr('value');
                var crmCampaignId = $frm.find('[name="sFDCLastCampaignID"]').attr('value');
                var crmCampaignName = $frm.find('[name="sFDCLastCampaignName"]').attr('value');
                var leadSourceMostRecent = $frm.find('[name="leadSourceMostRecent1"]').attr('value');
                var leadSourcePageTitleMostRecent = $frm.find('[name="leadSourcePageTitleMostRecent1"]').attr('value');
                var leadSourceDetailMostRecent = '';
                // SIBG cross-divisional form fields
                var mmmJobRole = $frm.find('[name="mmmJobRole1"]').val();
                var mmmIndustry = $frm.find('[name="mmmIndustry1"]').val();
                var inquiryType = $frm.find('[name="inquiryType1"]').val();
                // PSD-specific form fields
                var productSolutionInterest = $frm.find('[name="productSolutionofInterest1"]').val();
                var numberPPEUsers = $frm.find('[name="numberofPPEUsers1"]').val();
                // AAD-specific form fields
                var numberRepairsMonth = $frm.find('[name="numberofRepairsperMonth1"]').val();
                var numberRepairTechs = $frm.find('[name="numberofRepairTechnicians1"]').val();
                // ASD-specific form fields
                var numberAbrasiveOps = $frm.find('[name="numberofAbrasiveOperators1"]').val();
                var usingAutoASD = $frm.find('[name="usingAutomationASD1"]').val();
                // IATD-specific form fields
                var applicationPurposeSIBG = $frm.find('[name="iBGApplicationPurpose1"]').val();
                var applicationCategorySIBG = $frm.find('[name="iBGApplicationCategory1"]').val();
                var substrateIATD = $frm.find('[name="substrateIATD1"]').val();
                // EMD-specific form fields
                var companyType = $frm.find('[name="companyType1"]').val();
                var projectPhaseEMD = $frm.find('[name="projectPhaseEMD1"]').val();
                // CMSD-specific form fields
                var numberEmployees = $frm.find('[name="numberofEmployees1"]').val();
                var numberBoxesSealedDay = $frm.find('[name="numberofBoxesSealedperDayCMSD1"]').val();
                if($frm.find('[name="leadSourceDetailMostRecent1"]').length > 0) {
                    if($frm.find('[name="leadSourceDetailMostRecent1"]').attr('value') == '' || $frm.find('[name="leadSourceDetailMostRecent1"]').attr('value') == undefined) {
                        leadSourceDetailMostRecent = $frm.find('[name="leadSourceDetailMostRecent1"]').attr('value');
                        $frm.find('[name="leadSourceDetailMostRecent1"]').val(popFormName);
                    }
                }
                if($frm.find('[name="leadSourceDetailMostRecentLT1"]').length > 0) {
                    if($frm.find('[name="leadSourceDetailMostRecentLT1"]').attr('value') == '' || $frm.find('[name="leadSourceDetailMostRecentLT1"]').attr('value') == undefined) {
                        leadSourceDetailMostRecent = $('[name="leadSourceDetailMostRecentLT1"]').attr('value');
                        $frm.find('[name="leadSourceDetailMostRecentLT1"]').val(popFormName);
                    }
                }
                if($leadSourcePageTitleMostRecent.length > 0) {
                    if(leadSourcePageTitleMostRecent == '' || leadSourcePageTitleMostRecent == undefined) {
                        $leadSourcePageTitleMostRecent.val(document.title)
                    }
                }

                if (typeof utag !== 'undefined' && typeof utag.link !== 'undefined') {
                    utag.link({ "event_type" : "Conversion Events", "event_name" : "form submission", "form_name" : popFormName, "site_id"	: siteId, "ma_campaign"	: elqCampaignId, "tracking_code"	: trackingCode, "form_country"	: elqFormCountry, "language"	: language, "division"	: division, "crm_campaign_id" : crmCampaignId, "crm_campaign_name": crmCampaignName, "lead_source_1" : leadSourceMostRecent, "lead_source_2" : leadSourceDetailMostRecent, "email_address" : emailAddress, "mmm_job_role" : mmmJobRole, "mmm_industry" : mmmIndustry, "inquiry_type" : inquiryType, "product_solution_interest" : productSolutionInterest, "number_ppe_users" : numberPPEUsers, "number_repairs_monthly" : numberRepairsMonth, "number_repair_techs" : numberRepairTechs, "number_abrasives_operators" : numberAbrasiveOps, "using_automation_asd" : usingAutoASD, "sibg_application_purpose" : applicationPurposeSIBG, "sibg_application_category" : applicationCategorySIBG, "substrate_iatd" : substrateIATD, "company_type" : companyType, "project_phase_emd" : projectPhaseEMD, "number_employees" : numberEmployees, "number_boxes_sealed_daily" : numberBoxesSealedDay});
                }
                
                if (submitMethod === 'ajax') {
                    $debug('Submitting AJAX Request... form data on next line', 'elqForms');
                    var frmData = $frm.serialize();
                    $debug(frmData, 'elqForms');
                    $.ajax({
                        'url': url,
                        'type': ajaxType,
                        'data': frmData,
                        'dataType': dataType,
                        success: function (data) {
                            $debug('    # Success Function... checking data for accuracy. Data on next line', 'elqForms');
                            $debug(data, 'elqForms');
                            $debug('Comparing data.status against list. value = ' + data.status, 'elqForms');
                            switch (data.status) {
                                case 'success':
                                    $debug('    Hiding the Form... ', 'elqForms');
                                    $(form).addClass('MMM--isVisuallyHidden');
                                    $debug('data was expected... show success', 'elqForms');
                                    $successElement.removeClass('MMM--isVisuallyHidden').attr('aria-hidden','false');
                                    $('html, body').animate({
                                        scrollTop: $successElement.offset().top + (-105)
                                    }, 10);
                                    break;
                                case 'error':
                                    $debug('    Hiding the Form... ', 'elqForms');
                                    $(form).addClass('MMM--isVisuallyHidden');
                                    $debug('status was error... display error message', 'elqForms');
                                    $errorElement.removeClass('MMM--isVisuallyHidden').attr('aria-hidden','false');
                                    $('html, body').animate({
                                        scrollTop: $errorElement.offset().top + (-105)
                                    }, 10);
                                    break;
                                default:
                                    $debug('data.status was unexpected value... throw error state', 'elqForms');
                                    $errorElement.removeClass('MMM--isVisuallyHidden').attr('aria-hidden','false');
                                    break;
                            };
                        },
                    error: function (jqXHR, testStatus, errorThrown) {
                        $debug('    # Error Function: ' + errorThrown, 'elqForms');
                        $errorElement.removeClass('MMM--isVisuallyHidden').attr('aria-hidden','false');
                    },
                    complete: function () {

                    }
                });
                $(form).attr('data-ajaxsent', 'true'); // prevents duplication of submissions   
            } else {
                $debug('    Submitting form directly to Eloqua', 'elqForms');
                $frm.attr('action', url);
                form.submit();
            }

        } // End if statement for $(form).attr('data-ajaxsent')
    };

    /**
     * Global function to remove specific country options from any form if needed for legal reasons
     * @param {countryRegex} object|array Regular expression for to match to the option's value attribute for removal from the page, may be an array where the function will be called for each entry
     * @returns null
     */
    window.$removeCountryForm = function (countryRegex) {
        $debug('  In removeCountryForm...');

        // If the parameter is an array, call the function again for each entry
        if (Array.isArray(countryRegex)) {
            $debug('    Array of countries found, excluding each entry that contains a valid regex...');

            for (var i=0; i<countryRegex.length; i++) {
                $debug('      Re-invoking removeCountryForm with regex param:');
                $debug(countryRegex[i]);
                
                window.$removeCountryForm(countryRegex[i]);
            }
        } else if (typeof countryRegex !== 'object' || typeof countryRegex.test !== 'function') {
            $debug('    Error: countryRegex parameter is not a regular expression');

            return
        } else {
            $debug('    Country to remove regular expression:');
            $debug(countryRegex);

            $('option').each(function(){
                var optVal = $(this).val();

                if (countryRegex.test(optVal)) {
                    $debug('      Country to remove found in form, removing <option> element:');
                    $debug($(this));

                    $(this).remove();
                }
            });
        }
    }

        /**
         * Global function to scan through objects and convert any 'true' or 'false' that are defined as strings and convert them to boolean
         * @returns object
         *
         */		
		window.$convertBooleans = function (dataObj) {
            $debug('  In convertBooleans...');
			$debug('    Original data:');
			$debug(dataObj);
			
			var self = this,
				returnObj = {};
			
			if (typeof dataObj == 'object') {
				$.each(dataObj, function (key, val) {
					returnObj[key] = $convertBooleans(dataObj[key]);
				});
			} else if (dataObj == "true" || dataObj == "false") {
				returnObj = JSON.parse(dataObj); // Use JSON.parse to convert string to boolean
			} else {
				returnObj = dataObj;
			}
			
			$debug('    Boolean converted data:');
			$debug(returnObj);
			
			return returnObj;			
		}

        /**
         * Global function to determine if the user is in authoring mode, useful for blocking scripts that may interfere with authoring processes
         * @returns boolean
         *
         */		
		window.isAuthMode = function () {
            $debug('  In isAuthMode...');
			
			if(urlHash['uri'] === 'utb%3Aopen') {
				$debug('    Page is in authoring mode...');
				
				return true;
			} else {
				return false;
			}
		}

        /**
         * Global function to toggle active/inactive state on elements using standard MMM--isActive and MMM--isInactive classes
         * @returns boolean
         *
         */
		window.$toggleActive = function ($el) {
			if ($el.hasClass('MMM--isActive')) {
				$el.removeClass('MMM--isActive');
				$el.addClass('MMM--isInactive');

				return false;
			} else {
				$el.removeClass('MMM--isInactive');
				$el.addClass('MMM--isActive');

				return true;
			}

			return;
		}

        /**
         * Global function to set active state on elements using standard MMM--isActive class, also removes MMM--isInactive class
         * @returns boolean
         *
         */
		window.$setActive = function ($el) {
			if (!$el.hasClass('MMM--isActive')) {
				$el.addClass('MMM--isActive');
				$el.removeClass('MMM--isInactive');

				return true;
			}

			return;
		}

        /**
         * Global function to set inactive state on elements using standard MMM--isInactive class, also removes MMM--isActive class
         * @returns boolean
         *
         */
		window.$setInactive = function ($el) {
			if ($el.hasClass('MMM--isActive')) {
				$el.removeClass('MMM--isActive');
				$el.addClass('MMM--isInactive');

				return true;
			}

			return;
		}

        /**
         * Global function to add elements to the breadcrumb
         *
         * @param baseUrl (String) - The URL to apply to the last non-link element in the original breadcrumb
         * @param newCrumbs (Array) - An array of objects containing link text and (optional) URL for each new breadcrumb link
         *
         */
		window.$addBreadcrumb = function (baseUrl, newCrumbs) {
			var $themeBreadcrumb = $('.MMM--breadcrumbs_theme .MMM--breadcrumbs-list'),
                $themeBCClone = $themeBreadcrumb.find('li:first-child()').clone(), // Clone the first breadcrumb link as a template for new links
                $themeBCLast = $themeBreadcrumb.find('li:last-child()'),
                $themeBCLastClone = $themeBCLast.clone(), // Clone the last breadcrumb as a template for the new last item
                themeBCLastTxt = $themeBCLast.find('span').text(), // We need the text from the initial last so we can construct the link
                $newLastBC = $themeBCClone.clone(); // Create new breadcrumb with a link

            $newLastBC.find('a').attr('href', baseUrl); // Configure href to provided base URL
            $newLastBC.find('a').text(themeBCLastTxt); // Configure link text to match the original last breadcrumb
            $themeBCLast.html($newLastBC.html()); // Replace the HTML of the last breadcrumb with the HTML that was created

            for (var i=0,l=newCrumbs.length; i<l; i++) { // Loop through new breadcrumbs
                var $thisCrumb;

                if (i === l-1) { // The last breadcrumb will not contain a link
                    $thisCrumb = $themeBCLastClone.clone();
                    $thisCrumb.find('span').text(newCrumbs[i].text); // Change span text to the provided value
                } else {
                    $thisCrumb = $themeBCClone.clone();
                    $thisCrumb.find('a').attr('href', newCrumbs[i].url).text(newCrumbs[i].text); // Change link href and text to provided values
                }

                $themeBreadcrumb.append($thisCrumb); // Append the new breadcrumb
            }

			return;
		}


        //Output info messages when ?debug=corpJS is present

        $debug('~~____~~__~~__~~~~~~~~~~~~~~~~~~~~~~~~~~~~~_~~~~~~~~~~~~~~~~~~~_____~~~~~~~~~~~_~~~~~~~_~~~');
        $debug('~|___~\\|~~\\/~~|~~~~~~~~~~~~~~~~~~~~~~~~~~~|~|~~~~~~~~~~~~~~~~~/~____|~~~~~~~~~(_)~~~~~|~|~~');
        $debug('~~~__)~|~\\~~/~|~~___~___~~_~__~___~~~~~~~~|~|~__~___~~~____~_|~(___~~~___~_~__~_~_~__~|~|_~');
        $debug('~~|__~<|~|\\/|~|~/~__/~_~\\|~\'_~`~_~\\~~~_~~~|~|/~_`~\\~\\~/~/~_`~|\\___~\\~/~__|~\'__|~|~\'_~\\|~__|');
        $debug('~~___)~|~|~~|~||~(_|~(_)~|~|~|~|~|~|~|~|__|~|~(_|~|\\~V~/~(_|~|____)~|~(__|~|~~|~|~|_)~|~|_~');
        $debug('~|____/|_|~~|_(_)___\\___/|_|~|_|~|_|~~\\____/~\\__,_|~\\_/~\\__,_|_____/~\\__zx_|_|~~|_|~.__/~\\__|');
        $debug('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~|~|~~~~~~~~');
        $debug('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~|_|~~~~~~~~');
        $debug('');
        $debug('                        jQuery Version ' + jQuery.fn.jquery);
        $debug('                        3M.com Corporate Javascript v' + SETTINGS.APP_VERSION + (SETTINGS.IS_PRODUCTION ? '-Prd' : '-Dev'));
        $debug('                        See https://go.3M.com/corpJS for details                            ');
        $debug('                        See https://go.3M.com/corpJS-changelog for changelog                ');


        //When ?debug=corpJS&sanity=check is present, run the following
        if (urlHash.sanity) {
            $debug('****** UTIL JS FUNCTION SANITY CHECK ******');
            $debug('     Domain is: ' + $getDomain(true));
            var testJSON = {
                'company': {
                    'name': '3M',
                    'city': 'St. Paul, MN'
                },
                'foo': 'bar',
                'hello': 'world',
                'value': 400
            };

            $debug('     Test of $printObj: ' + $printObj(testJSON));
            $debug('     Setting Cookie Named mmmJSTest');
            $setCookie('mmmJSTest', 'this is cookie!!!');
            $debug('     Getting Cookie Value for mmmJSTest...  Cookie Value is: ' + $getCookie('mmmJSTest'));
            $debug('     URL Parameters = ' + urlHash);
            $debug('     Current Layout = ' + $getLayout(true));
            $debug('****** END UTIL JS FUNCTION SANITY CHECK ******');
        }


        // //Unicorn SVG Animation to header/footer
        // if(SETTINGS.svgBorder===true){
        //     $('.MMM--theme-hd').after('<div class="MMM--upperBottomBorder"></div>');
        //     $('.MMM--theme-ft').before('<div class="MMM--lowerTopBorder"></div>');
        //     $debug('svg is true', 'mmmSVG');
        // }
        // else{
        //     $debug('Not firing the settings.svg true statment','mmmSVG');
        // }


        /**
         * Turncate the text after 75 characters;
         *
         * @returns number of character turncated
         */
		Util.truncateTxt = function(obj){
			$debug('TruncateTxt Utility Function loaded');
			var ellipsesSel = obj;
		
			$(ellipsesSel).each(function(ele){
				$debug('ele ----- '+ele);
				var options = $(this).data().options,
					defaults = {maxCharacters: 75, dots: '...'},
					settings = $.extend({}, defaults, options),
					charLimit = settings.maxCharacters,
                    dots = settings.dots,
					text = $(this).text(),
					textArray = text.split(''),
					textArrayLength = textArray.length,
					newText = '';
		
				if(text != null){
					if (textArrayLength > charLimit) {
                        for (var i = 0; i < charLimit; i++) {
                            newText += textArray[i];
                        }
                        if(dots) {
                            newText = newText + dots;
                        }
					}
                    else {
                        newText = text;
                    }
                    $(this).html(newText);
                }
            });
        };

        /**
         * A utility function to add the social footer
         * to be a part of the ribbon div container
         * @returns on desktop add the social footer to ribbon div
         */
        Util.socialFooter = function (obj) {
            $debug('socialFooter Utility Function loaded');

            var $socialFtMobile = $('.MMM--footerGrids-col_socialMedia');
            var $socialFtDesktop = $socialFtMobile.clone('true');

            $socialFtMobile.addClass('MMM--isNotOnDesktop');
            $socialFtDesktop.addClass('MMM--isOnDesktop');

            $socialFtDesktop.css('position', 'absolute');
            $socialFtDesktop.find('.MMM--socialMedia').css('margin-top', 50);
            $socialFtDesktop.find('.MMM--footerPanel_socialMediaPanel').css('padding-right', 0);
            $socialFtDesktop.find('.MMM--footerPanel_socialMediaPanel').css('padding-left', 0);

            $('.MMM--ribbon').append($socialFtDesktop);
        };

        /**
         * A utility function to Jump to Top Navigation
         * @returns scroll back to the rN-JumpMenu MMM--TopJumpMenu ID
         */
        Util.mmmScrollToJumpMenu = function (obj) {
            $debug('Scroll to Jump Menu Utility Function loaded');
            var jumpTop = obj,
                stop = $(jumpTop).offset().top,
                delay = 1000;

            $('body,html').animate({
                scrollTop: stop
            }, delay);
            return false;
        };

        /**
         * A utility function to remove the <p dir="ltr">&nbsp;</p>
         * @returns removes the single <p> tag with &nbsp;
         */
        Util.removePtagwithSpace = function (obj) {
            $debug('removePtagwithSpace Utility Function loaded');
            var removePTag = obj;
            $(removePTag).each(function () {
                var text = $.trim($(this).html());
                //$debug('removePtagwithSpace in each ==' +text);
                if (text === ' ' || text === '&nbsp;') {
                    $debug('removePtagwithSpace in IF');
                    $(this).remove();
                }
            });
            return false;
        };
         /**
         * A utility has been added to disable a link after its first click
         * 
         */
        if ($('body').find('.js-disableAfterClick').length > 0){
            $debug("found a button to disable");
            $('.js-disableAfterClick').on('click', function(e) {
                e.preventDefault();
                $(this).off("click").attr('href', "javascript: void(0);");
                $debug("button disabled");
              });
        };

        /**
         * Verifies if there are query strings in the URL
         */
        Util.checkForQueryParams = function( url ){ 
            var notFound = -1;
            return !( url.indexOf('?') == notFound ); 
        };

        return Util;

    });


}(MMMRequire));
// JavaScript Document
;